var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.handleFileChange}}),_c('button',{staticClass:"button is-link",attrs:{"id":"app-upload-btn"},on:{"click":_vm.uploadTask}},[_vm._v(_vm._s(_vm.$t(_vm.btnFunc)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }